import React from 'react';
import TopBanner from '../MainContents/TopBanner'; 
import ScrollToTopOnMount from '../MainContents/AutoScrollTop'; 
import DiscountProgram from './DiscountProgram.jsx'; 

import Img1 from '../../img/Explanation1.JPEG'
import Img2 from '../../img/Explanation2.JPEG'
import Img3 from '../../img/Explanation3.JPEG'
import styled from 'styled-components';


const Heading = styled.h2`
    margin-bottom: 30px;
    padding: 15px;
    font-size: 24px;
    font-size: 1.5rem;
    background-image: linear-gradient(0deg, #990820 0%, #ba0020 100%) !important;
    color: #fff;
    border-radius: 7px;
`;

const MarginWid = styled.div`
    width: 90%;
    margin:auto;
`;



// はりまやYT教室について
class Explanation extends React.Component {
  render() {
    return (
        <>
            {/*　トップバナー */}
            <TopBanner  title="はりまやYT教室について" 
                        text1="土佐塾だから頑張れる！" 
                        text4="はりまやYT教室だから、自信が持てる!" 
                         />
            <ScrollToTopOnMount />
    
            <MarginWid>
                <Heading>はりまやYT教室＝土佐塾の難関中学受験専門教室</Heading>
                <div className="card mb-3 border-0">
                    <div className="row g-0">
                        <div className="col-md-8">
                            <div className="card-body">
                                <p className="card-text">
                                    はりまやYT教室は、「県外の超難関中合格、及び土佐中絶対合格、<br />
                                    そして土佐塾中と学芸中の特待生合格」を目指す土佐塾の中学受験専門教室です。
                                </p>
                
                            </div>
                        </div>
                        <div className="col-md-4">
                            <img src={Img1} alt="..." style={{width:'100%'}} />
                        </div>
                    </div>
                </div>

                <Heading>四谷大塚ならではの志望校に合格できる４つの柱</Heading>
                <div className="card mb-3 border-0">
                    <div className="row g-0">
                        <div className="col-md-8">
                            <div className="card-body">
                                
                                <p>全国の四谷大塚直営教室と全く同じスタイルで学び、ワンランク上の学力を身につけ志望校合格をより確実にしていきます。また、「はりまやYT教室」は、"全国難関中受験
                                    対応のカリキュラム"、"すぐれた教材"、"わかりやすい授業"、"習熟度のチェック"を学習の４つを柱にしています。</p>
                                <ul className="card-text">
                                    <li>小学５年生終了時で入試に必要な単元をほぼ習得。小学６年生時は、復習をしっかり行い、志望校絶対合格を目指して学力をUP！</li>
                                    <li>土佐塾を代表する県内無双のベテラン講師陣が授業を担当！</li>
                                    <li>定評のある四谷大塚の教材『予習シリーズ』やサブテキストを授業や個別指導で使用！</li>
                                    <li>四谷大塚ならではの『週例テスト』や『公開組分けテスト』を受け、全国レベルでの学力をチェック！</li>
                                    
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <img src={Img2} alt="..." style={{width: '100%'}} />
                        </div>
                    </div>
                </div>

                <Heading>はりまやYT教室の教育姿勢</Heading>
                <div className="card mb-3 border-0">
                    <div className="row g-0">
                        <div className="col-md-8">
                            <div className="card-body">
                                <p>「夢」、「探求心」、「志」、「努力」、「自信」そして「思いやりの心」。</p>
                                <p className="card-text">
                                    はりまやYT教室は、子ども達一人一人の「夢」を大切にします。また、ものごとの本質を探り、見究め、
                                    明らかにしようとする「探求心」を育むことのできる授業を常に心掛けています。さらに、しっかりとした
                                    「志」を持ち、「志」の達成のために「努力」を惜しまず、「努力」に裏付けられた「自信」が持てる
                                    子ども達に成長して欲しいと思っています。そして、子ども達が他者に対して「思いやり」のある、強きリーダーになって欲しいと願っています。
                                    
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <img src={Img3} alt="..." style={{width: '100%'}} />
                        </div>
                    </div>
                </div>

                {/* 割引制度 */}
                <Heading>特待生制度、兄弟割引も充実</Heading>
                <DiscountProgram />
                
                

            </MarginWid>
        </>
    );
  }
}

export default Explanation;
